import { GenericPage } from "../../../../../pages";
import { videosRoute } from "./resources-videos.route";


export const resourcesRoute = [
  {
    path: 'videos',
    element: <GenericPage />,
    children: videosRoute,
  },
]